import { WebComponents } from "@/interfaces";
import { URLS } from "../../utils";
import { Library, Megaphone, Calendar, ShieldCheck, Star, Users, Contact, Bell, Settings } from "lucide-react";

export const webComponents: {
  title: string;
  path: string;
  componentIds: WebComponents[] | WebComponents;
  description: string;
  icon: any;
}[] = [
  {
    title: "Library",
    path: URLS.coach.library,
    componentIds: [
      WebComponents.PROMPTS,
      WebComponents.MANAGE_SCRIPT_LIBRARY,
      WebComponents.VIDEO_CATALYST,
      WebComponents.VIDEO_PAGES,
    ],
    description: "Manage prompts, scripts, and videos to empower your content creation.",
    icon: Library,
  },
  {
    title: "Campaigns",
    path: URLS.coach.campaigns,
    componentIds: WebComponents.CAMPAIGNS,
    description: "Design, track, and optimize social media campaigns for your players.",
    icon: Megaphone,
  },
  {
    title: "Calendar",
    path: URLS.coach.calendar,
    componentIds: WebComponents.CALENDAR,
    description: "Review and organize content posts on a centralized calendar.",
    icon: Calendar,
  },
  {
    title: "Compliance Manager",
    path: URLS.coach.compliance,
    componentIds: WebComponents.COMPLIANCE,
    description: "Monitor, configure rules, and manage compliance across social platforms to ensure brand safety.",
    icon: ShieldCheck,
  },
  {
    title: "Reputation Manager",
    path: URLS.coach.reputation.overview,
    componentIds: [WebComponents.REPUTATION_MANAGEMENT],
    description: "Track reviews and manage online feedback for your brand.",
    icon: Star,
  },
  {
    title: "Users",
    path: URLS.coach.users,
    componentIds: [WebComponents.PLAYERS, WebComponents.ASSISTANTS],
    description: "Manage players, assistants, and other team members, including their roles and assignments.",
    icon: Users,
  },
  {
    title: "Player Cards",
    path: URLS.coach.playerCards,
    componentIds: WebComponents.PLAYER_CARDS,
    description: "Configure personalized digital brand and contact cards for players to share easily.",
    icon: Contact,
  },
  {
    title: "Alerts",
    path: URLS.coach.alerts,
    componentIds: WebComponents.ALERTS,
    description: "Stay on top of critical events, system notifications, and player updates.",
    icon: Bell,
  },
  {
    title: "Settings",
    path: URLS.coach.settings,
    componentIds: [WebComponents.APP_SETTINGS, WebComponents.API_KEYS],
    description: "Configure app preferences, brand themes and settings.",
    icon: Settings,
  },
];

export const playerWebOptions = [
  {
    title: "Dashboard",
    path: URLS.player.dashboard,
  },
  {
    title: "Library",
    path: URLS.player.libraryTab.replace(":tab?", ""),
  },
  {
    title: "Calendar",
    path: URLS.player.calendar,
  },
  {
    title: "Review Inbox",
    path: URLS.player.reputation.reviews,
  },
  {
    title: "Player Card",
    path: URLS.player.playerCards,
  },
  {
    title: "Settings",
    path: URLS.player.settings.replace(":tab?", ""),
  },
];
